import type { TFunction } from "i18next";
import type { RailMenuEntry } from "./RailMenu";

// Las tres variantes de Informes. Las comparten el menú del riel (escritorio)
// y la barra segmentada de ReportLayout (móvil, donde el riel no existe): si
// cada una tuviera su copia, una ruta nueva entraría en una y no en la otra.
export const reportMenuEntries = (t: TFunction): RailMenuEntry[] => [
  {
    id: "quick",
    label: t("appsRail.reports.quick", "Informes rápidos"),
    short: t("appsRail.reports.quickShort", "Rápidos"),
    hint: t("appsRail.reports.quickHint", "Al instante: hoy, ayer o hasta 15 días"),
    icon: "ri-flashlight-line",
    route: "/reports/quick",
    match: /^\/reports\/quick/,
  },
  {
    id: "analysis",
    label: t("appsRail.reports.analysis", "Informes y análisis"),
    short: t("appsRail.reports.analysisShort", "Análisis"),
    hint: t("appsRail.reports.analysisHint", "Los informes completos, con filtros y mapa"),
    icon: "ri-bar-chart-box-line",
    route: "/reports/history",
    match: /^\/reports\/(?!quick|scheduled)/,
  },
  {
    id: "scheduled",
    label: t("appsRail.reports.scheduled", "Informes programados"),
    short: t("appsRail.reports.scheduledShort", "Programados"),
    hint: t("appsRail.reports.scheduledHint", "Se generan y envían solos"),
    icon: "ri-calendar-schedule-line",
    route: "/reports/scheduled",
    match: /^\/reports\/scheduled/,
  },
];
